package org.chiangmeng.qfast.core.domain.usecases

import org.chiangmeng.qfast.core.domain.ports.QueueRepository

class IssueTicketUseCase(private val repository: QueueRepository) {
    suspend operator fun invoke(shopId: String, category: String): Int {
        return repository.issueTicket(shopId, category)
    }
}